import React from 'react';
import PropTypes from 'prop-types';

import Tracker from '../../../genesys/tracker';

export default class Delay extends React.Component {
    constructor() {
        super();
        this.componentTimeout = null;
    }

    componentDidMount() {
        if (this.props.showAfter > 0) {
            this.componentTimeout = setTimeout(() => this.show(), this.props.showAfter * 1000);
        } else if (this.props.showAfter === 0) {
            this.show();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.componentTimeout);
    }

    show() {
        if (this.props.hideAfter > 0) {
            this.componentTimeout = setTimeout(() => this.hide(), this.props.hideAfter * 1000);
        }
        this.props.onOpen ? this.props.onOpen() : null;
    }

    hide() {
        this.props.sendInviteTimeout ? Tracker.timeOutInvite() : null;
        this.props.onClose ? this.props.onClose() : null;
    }

    render() {
        return this.props.children;
    }
}

Delay.defaultProps = {
    showAfter: 0,
    hideAfter: 0,
    setInviteTimeout: false
};

Delay.propTypes = {
    showAfter: PropTypes.number,
    hideAfter: PropTypes.number,
    sendInviteTimeout: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    children: PropTypes.node.isRequired
};
